import { $date } from '@/plugins'
import type { Protocol, ProtocolInfo } from '@/types/app-data/member.types'

const formatMonthAndDay = (date: string) => {
  return $date(new Date(date)).format('MMM DD')
}

const isOutdated = (date: string) => {
  return $date(new Date(date)).diff($date(), 'day') < 0
}

const getProtocolInfo = (protocol: Protocol): ProtocolInfo => {
  return {
    name: protocol.protocol_name,
    currentPhase: protocol.protocol_current_phase_name,
    totalPhases: protocol.protocol_total_phases,
    startDate: formatMonthAndDay(protocol.protocol_created_at),
    endDate: formatMonthAndDay(protocol.protocol_expires_at),
    outdated: isOutdated(protocol.protocol_expires_at),
  }
}

export { getProtocolInfo }
